import {Component} from '@angular/core';
import {
  ArticleBodyDirective,
  ArticleTitleDirective,
  PolicyArticleComponent
} from "projects/soko-console-web-v2/src/app/features/support/policies/policy-article/policy-article.component";

@Component({
  selector: 'app-processing-sales-and-refunds-article',
  standalone: true,
  imports: [
    PolicyArticleComponent, ArticleTitleDirective, ArticleBodyDirective
  ],
  styleUrl: './styles/support-policy-articles-common.scss',
  template: `
    <app-policy-article>
      <span articleTitle>Processing sales and refunds</span>
      <div articleBody class="body-1-regular-1">

        <section>
          <div class="heading">Applicability</div>
          <div>This policy applies to:</div>
          <ul>
            <li>All linked point of sale (POS) accounts, including but not limited to Lightspeed Retail-X (VEND).</li>
            <li>All card payment devices, including but not limited to YOCO devices.</li>
          </ul>
        </section>
        <section>
          <div class="heading">Unauthorized Use</div>
          <ul>
            <li>
              Only payment devices specifically issued to the retailer for use with their linked POS account may be
              utilized.
            </li>
            <li>Using any other card payment device, including those belonging to another retailer, is prohibited.</li>
            <li>
              Using a card payment device not linked to the retailer’s POS account constitutes operation outside of
              authorized procedures. In such cases, the retailer is responsible for any financial discrepancies and must
              address the recovery of funds independently, as the transaction is effectively processed through another
              store.
            </li>
          </ul>
        </section>
        <section>
          <div class="heading">Multiple Leases and Supplier Integration</div>
          <div>For POS accounts with multiple leases:</div>
          <ul>
            <li>
              Retailers must be registered in the POS system as suppliers, and their products should be linked
              accordingly to ensure proper sales processing by the platform.
            </li>
            <li>
              Failure to link products to their respective suppliers absolves Nter from any liability related to
              unallocated funds or incorrect payouts.
            </li>
          </ul>
        </section>
        <section>
          <div class="heading"> Product Management</div>
          <div>
            Discontinued or obsolete products must be marked as deactivated or unavailable in the linked POS system;
            they should not be deleted to maintain accurate records for reconciliation.
          </div>
        </section>
        <section>
          <div class="heading">Sales and Refund Processing</div>
          <ul>
            <li>
              All sales and refunds must be processed through the linked POS system, such as Lightspeed Retail-X
              (VEND), to ensure accurate payouts.
            </li>
            <li>
              Only the card reader(s) specifically issued to the retailer for their linked POS account must be used.
              The use of any card reader not issued for the specific POS account, including borrowing from other
              retailers, is prohibited and can lead to processing errors and incorrect financial settlements.
            </li>
            <li>
              The use of any other POS systems for sales or refunds
              <ul>
                <li>Constitutes operating outside and/or circumventing of the Nter platform, its policies and processes
                  and may result in interrupted or terminated service.
                </li>
                <li>Will result in those transactions not being processed by the Nter platform.</li>
              </ul>
            </li>
          </ul>
        </section>
        <section>
          <div class="heading">Compliance and Liability</div>
          <div>
            Failure to adhere to these guidelines can result in disrupted service and potential financial liability for
            the retailer. Nter reserves the right to update these policies as necessary to maintain system integrity and
            compliance.
          </div>
        </section>
      </div>
    </app-policy-article>
  `
})
export class ProcessingSalesAndRefundsArticleComponent {

}
